import { css } from '@emotion/react';

export const policyStyles = {
    modalContainer: css({
        backgroundColor: '#fff',
        margin: 'auto',
        borderRadius: '8px',
    }),
    closeButtonBlock: css({
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
    }),
    closeButton: css({
        padding: '6px',
        height: '24px',
        width: '24px',
        cursor: 'pointer',
    }),
    title: css({
        fontWeight: 700,
        fontSize: '13px',
        lineHeight: '13px',
        color: '#000000',
        margin: 0,
    }),
    private_createTypography: css({
        fontWeight: 400,
        fontSize: '13px',
        lineHeight: '13px',
        color: '#000000',
        marginBottom: '13px',
    }),
    paragraph: css({
        fontWeight: 400,
        fontSize: '13px',
        margin: 0,
    }),
    paragrapghEnd: css({
        marginBottom: '13px',
    }),
    listUl: css({
        padding: '0 0 0 10px',
        listStyleType: 'none',
        margin: 0,
    }),
    listLi: css({
        margin: 0,
        padding: 0,
        fontSize: '13px',
        fontWeight: 400,
        color: '#000000',
        position: 'relative',
        paddingLeft: '12px',
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: '7px',
            width: '3px',
            height: '3px',
            backgroundColor: '#000000',
            borderRadius: '50%',
        },
    }),
};
